import { render } from "./erro_alerta.vue?vue&type=template&id=b328c69e"
import script from "./erro_alerta.vue?vue&type=script&lang=js"
export * from "./erro_alerta.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__